<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <dark-Toggler />
      
      <b-nav-item-dropdown class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right>

        <template #button-content>
          <feather-icon badge="1" badge-classes="bg-primary" class="text-body" icon="BellIcon" size="21" />
        </template>

        <!-- Header -->
        <li class="dropdown-menu-header">
          <div class="dropdown-header d-flex">
            <h4 class="notification-title mb-0 mr-auto">
              系统消息
            </h4>
            <b-badge pill variant="light-primary">
              1
            </b-badge>
          </div>
        </li>

        <!-- Notifications -->
        <vue-perfect-scrollbar v-once 
          class="scrollable-container media-list scroll-area" tagname="li">
          <!-- Account Notification -->
          <b-media>
            <template #aside>
              <b-avatar size="32" src="" text="" variant="danger" />
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                声明：
              </span>
            </p>
            <small class="notification-text">本站提供之服务仅限于足彩等合法分析之用，严禁使用本站提供之任何资料用于任何赌博性质活动！</small>
          </b-media>

        </vue-perfect-scrollbar>

      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-navbar-nav class="nav align-items-center ml-auto">
      

      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user">
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ username }}
            </p>
            <span class="user-status">尊贵VIP会员</span>
          </div>
          <b-avatar size="40" variant="light-primary" badge :src="require('@/assets/images/head.jpg')"
            class="badge-minimal" badge-variant="success" />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center" :to="{ name: 'accountSetting' }">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>个人中心</span>
        </b-dropdown-item>


        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>退出登录</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    VuePerfectScrollbar,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },

  data() {
    return {
      username: localStorage.getItem('soccer_username'),
    };
  },

  methods:{
    logout() {
      localStorage.setItem('soccer_token','');
      this.$router.push('/login');
    }
  }

}
</script>
